import { useEngagementService } from './useEngagementService'

export const EngagementService = () => {
  useEngagementService()

  return null
}
